import clsx from "clsx"

type SimpleArticleTeaserLoadingProps = {
  readonly className?: string
  readonly hasBodyText?: boolean
}

export function SimpleArticleTeaserLoading({
  className,
  hasBodyText = false,
}: SimpleArticleTeaserLoadingProps) {
  return (
    <div className={clsx(className, "grid grid-cols-1 gap-2")}>
      <div className="h-2 w-[200px] animate-pulse bg-whisper motion-reduce:animate-none" />
      <div className="h-[1.375rem] w-1/2 animate-pulse bg-whisper motion-reduce:animate-none" />
      {hasBodyText ? (
        <div className="h-[80px] w-1/2 animate-pulse bg-whisper motion-reduce:animate-none" />
      ) : null}
      <div className="h-2 w-[200px] animate-pulse bg-whisper motion-reduce:animate-none" />
    </div>
  )
}
